import { gql } from '@apollo/client'
import { BaseBlock, BlockFragment } from '../../../shared/blocks/blocks.types'

export const ForYouBlockFragment: BlockFragment = {
  name: 'forYou',
  fragment: gql`
    fragment forYou on ForYou {
      id
      blockType
      blockName
      offers {
        id
        name
        description
        tag
        featuredImage {
          url
          alt
        }
        thumbnailImage {
          url
        }
        expiresAt
        slug
        brand {
          id
          logo {
            id
            url
            alt
          }
          slug
        }
        offerLinkLabel
        offerLink
      }
      excludedPlatforms {
        ios
        android
        web
      }
    }
  `,
  partialFragment: `
    ...on ForYou {
      id
      blockType
      blockName
      offers {
        id
        name
        description
        tag
        featuredImage {
          url
          alt
        }
        thumbnailImage {
          url
        }
        expiresAt
        slug
        brand {
          id
          logo {
            id
            url
            alt
          }
          slug
        }
        offerLinkLabel
        offerLink
      }
      excludedPlatforms {
        ios
        android
        web
      }
    }
  `,
}

export const ForYouBlockType = 'forYou'

export interface ForYouBlock extends BaseBlock {
  blockType: typeof ForYouBlockType
  id: string
  offers?: {
    id: string
    name: string
    description?: string
    tag?: string
    featuredImage: {
      url: string
      alt: string
    }
    expiresAt?: string
    slug: string
    brand: {
      logo: {
        url: string
        alt: string
      }
    }
    offerLinkLabel?: string
    offerLink?: string
  }[]
}
